import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToListPage = () => {
  const { navigation } = useNavigation()

  const to = navigation.settings.automations.list.fullPath()

  return <Navigate to={to} />
}

export default RedirectToListPage
